import React from "react";
import ReactDOM from "react-dom";

//Redux
import { Provider } from "react-redux";

//Store
import dataStore from "./configureStore";

//Styles
import "./style/index.css";

//Components
import App from "./App";

ReactDOM.render(
  <Provider store={dataStore}>
    <App />
  </Provider>,
  document.getElementById("root")
);
